document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('CartDrawer');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');

  const formatMoney = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    return `$${(cents / 100).toFixed(2)}`;
  };

  const updateCartCount = (count) => {
    cartCountEls.forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('cart-count--bump');
      void el.offsetWidth;
      el.classList.add('cart-count--bump');
    });
  };

  async function loadCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    updateCartCount(cart.item_count);
    const el = document.getElementById('CartDrawerContent');
    if (!el) return;

    if (!cart.items.length) {
      el.innerHTML = '<div class="empty-cart"><p>Your cart is currently empty.</p><a class="btn btn-primary" href="/collections/all">Continue shopping</a></div>';
      return;
    }

    el.innerHTML = cart.items.map((item) => `
      <div class="cart-line">
        <img src="${item.image || ''}" alt="">
        <div>
          <strong>${item.product_title}</strong>
          <div>${item.variant_title || ''}</div>
          <div>${item.quantity} × ${formatMoney(item.final_price)}</div>
        </div>
      </div>
    `).join('') + `
      <hr>
      <p><strong>Subtotal: ${formatMoney(cart.total_price)}</strong></p>
      <a class="btn btn-primary" href="/checkout">Checkout</a>
    `;
  }

  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!drawer) return;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      loadCart();
    });
  });

  document.querySelectorAll('[data-drawer-close]').forEach((button) => {
    button.addEventListener('click', () => {
      drawer?.classList.remove('open');
      drawer?.setAttribute('aria-hidden', 'true');
    });
  });

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuDrawer = document.querySelector('[data-menu-drawer]');
  const setMenuOpen = (open) => {
    if (!menuToggle || !menuDrawer) return;
    menuToggle.setAttribute('aria-expanded', String(open));
    menuDrawer.setAttribute('aria-hidden', String(!open));
    menuDrawer.classList.toggle('open', open);
    document.body.classList.toggle('menu-open', open);
  };
  menuToggle?.addEventListener('click', () => setMenuOpen(menuToggle.getAttribute('aria-expanded') !== 'true'));
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => setMenuOpen(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenuOpen(false);
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-main-image]');
    const thumbs = [...gallery.querySelectorAll('.thumb')];
    const current = gallery.querySelector('[data-gallery-current]');
    const thumbsContainer = gallery.querySelector('[data-thumbs]');
    let index = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('active')));

    function show(nextIndex) {
      if (!thumbs.length) return;
      index = (nextIndex + thumbs.length) % thumbs.length;
      thumbs.forEach((thumb, i) => thumb.classList.toggle('active', i === index));
      main.classList.add('is-changing');
      main.src = thumbs[index].dataset.src;
      main.dataset.mediaId = thumbs[index].dataset.mediaId || '';
      main.onload = () => main.classList.remove('is-changing');
      thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (current) current.textContent = String(index + 1);
    }

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    gallery.querySelector('.prev')?.addEventListener('click', () => show(index - 1));
    gallery.querySelector('.next')?.addEventListener('click', () => show(index + 1));
    gallery.querySelector('[data-thumb-prev]')?.addEventListener('click', () => thumbsContainer?.scrollBy({ left: -260, behavior: 'smooth' }));
    gallery.querySelector('[data-thumb-next]')?.addEventListener('click', () => thumbsContainer?.scrollBy({ left: 260, behavior: 'smooth' }));

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });

    let touchStartX = 0;
    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 45) show(delta > 0 ? index - 1 : index + 1);
    }, { passive: true });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[name="id"]');
    const price = document.querySelector('[data-product-price]');

    form.querySelectorAll('.variant-btn').forEach((button) => {
      button.addEventListener('click', () => {
        form.querySelectorAll('.variant-btn').forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        select.value = button.dataset.variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const option = select.selectedOptions[0];
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
        const mediaId = button.dataset.mediaId;
        if (mediaId) document.querySelector(`.thumb[data-media-id="${mediaId}"]`)?.click();
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      submit?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Unable to add item');
        await loadCart();
        drawer?.classList.add('open');
        drawer?.setAttribute('aria-hidden', 'false');
      } finally {
        submit?.removeAttribute('aria-busy');
      }
    });
  });

  document.querySelector('[data-sticky-atc]')?.addEventListener('click', () => {
    document.querySelector('[data-product-form] button[type="submit"]')?.click();
  });

  loadCart().catch(() => {});
});

// Perfect Paws v1.3 mobile collection filters
window.addEventListener('DOMContentLoaded', () => {
  const filterButton = document.querySelector('[data-filter-toggle]');
  const sidebar = document.querySelector('.collection-sidebar');
  if (filterButton && sidebar) {
    filterButton.addEventListener('click', () => sidebar.classList.toggle('is-open'));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') sidebar.classList.remove('is-open');
    });
  }
});


// Perfect Paws v1.5 native Shopify price filtering
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-facets-form]').forEach((form) => {
    const minInput = form.querySelector('[data-price-min]');
    const maxInput = form.querySelector('[data-price-max]');
    if (!minInput && !maxInput) return;

    const normalizePrices = () => {
      if (minInput && minInput.value !== '') minInput.value = Math.max(0, Number(minInput.value) || 0);
      if (maxInput && maxInput.value !== '') maxInput.value = Math.max(0, Number(maxInput.value) || 0);
      if (minInput?.value && maxInput?.value && Number(minInput.value) > Number(maxInput.value)) {
        maxInput.value = minInput.value;
      }
    };

    [minInput, maxInput].filter(Boolean).forEach((input) => {
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          normalizePrices();
          form.requestSubmit();
        }
      });
      input.addEventListener('change', () => {
        normalizePrices();
        form.requestSubmit();
      });
    });

    form.addEventListener('submit', normalizePrices);
  });
});
